import { Reveal } from "./Reveal";
import { Dumbbell, Flame, Users, ArrowUpRight, Waves, Calendar, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const IM = {
  bootcamp:
    "https://images.unsplash.com/photo-1607962837359-5e7e89f86776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxib290Y2FtcCUyMHRyYWluaW5nJTIwb3V0ZG9vcnxlbnwwfHx8fDE3ODUyNzg5Njd8MA&ixlib=rb-4.1.0&q=85",
  weights:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_bootcamp-gains/artifacts/yte6p3v1_jc%20coaching%20chloe%20pull%20up.jpg",
  coach:
    "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwY29hY2glMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODUyNzg5Njd8MA&ixlib=rb-4.1.0&q=85",
  paddle:
    "https://images.unsplash.com/photo-1540539234-c14a20fb7c7b?w=1600&q=80",
};

const Card = ({ icon: Icon, tag, title, body, img, className, big }) => (
  <div
    className={`group relative border border-[#222] bg-[#0b0b0b] overflow-hidden ${className}`}
    data-testid={`service-${tag.toLowerCase().replace(/\s/g, "-")}`}
  >
    {img && (
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={img}
          alt={title}
          className="h-full w-full object-cover opacity-30 group-hover:opacity-45 group-hover:scale-105 transition-all duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0b] via-[#0b0b0b]/60 to-transparent" />
      </div>
    )}
    <div className="relative z-10 flex h-full flex-col justify-between p-7 md:p-8">
      <div className="flex items-start justify-between">
        <Icon className="text-[#005EEA]" size={28} />
        <ArrowUpRight className="text-[#555] group-hover:text-white transition-colors" size={22} />
      </div>
      <div className={big ? "mt-24 md:mt-40" : "mt-16"}>
        <p className="font-mono-accent text-[10px] text-[#666] mb-3">{tag}</p>
        <h3 className="font-display text-white text-2xl md:text-4xl leading-none mb-3">{title}</h3>
        <p className="text-[#A0A0A0] text-sm md:text-base leading-relaxed max-w-md">{body}</p>
      </div>
    </div>
  </div>
);

export default function Services() {
  return (
    <section id="services" className="bg-[#050505] py-24 md:py-40 border-t border-[#222]" data-testid="services">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal className="mb-14 md:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="font-mono-accent text-[#005EEA] text-xs mb-4">What I Coach</p>
            <h2 className="font-display text-white text-5xl md:text-7xl lg:text-8xl leading-[0.9]">
              Programs built<br />to break plateaus
            </h2>
          </div>
          <p className="text-[#A0A0A0] max-w-sm md:text-right">
            Three ways to train with me — pick the intensity that matches your goal.
          </p>
        </Reveal>

        <Reveal>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:auto-rows-[300px]">
            <Card
              icon={Dumbbell}
              tag="1-on-1 Coaching"
              title="Personal Training"
              body="Private, fully bespoke sessions engineered around your body, schedule and goals."
              img={IM.weights}
              big
              className="md:col-span-7 md:row-span-2"
            />
            <Card
              icon={Flame}
              tag="S & C"
              title="Strength & Conditioning"
              body="Periodised programming to build raw power, speed and athletic resilience."
              img={IM.coach}
              className="md:col-span-5"
            />
            <Card
              icon={Users}
              tag="Group"
              title="Bootcamps"
              body="High-intensity squad training. Sweat, compete, and grow with the community."
              img={IM.bootcamp}
              className="md:col-span-5"
            />
          </div>
        </Reveal>

        {/* POWER THE PADDLE clinic spotlight */}
        <Reveal className="mt-4 md:mt-6">
          <Link
            to="/clinics/power-the-paddle"
            className="group relative block border border-[#005EEA]/40 bg-[#0b0b0b] overflow-hidden"
            data-testid="clinic-spotlight-card"
          >
            <div className="absolute inset-0 overflow-hidden">
              <img
                src={IM.paddle}
                alt="Power the Paddle — Paddler Performance Lab"
                className="h-full w-full object-cover opacity-25 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/80 to-[#001033]/60" />
            </div>
            <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-8 p-7 md:p-10">
              <div className="max-w-2xl">
                <div className="flex items-center gap-3 mb-4">
                  <span className="inline-flex items-center gap-2 bg-[#005EEA] text-white font-mono-accent text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
                    <Waves size={12} /> Featured Clinic
                  </span>
                  <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#005EEA]">20 spots only</span>
                </div>
                <h3 className="font-display text-white text-3xl md:text-5xl leading-none mb-3">
                  POWER THE PADDLE <span className="text-[#005EEA]">×</span> ALKAME
                </h3>
                <p className="text-[#A0A0A0] text-sm md:text-base leading-relaxed mb-5">
                  A 6-week strength & conditioning clinic built for paddlers — baseline assessment, progressive programming, and measurable gains.
                </p>
                <div className="flex flex-wrap gap-x-6 gap-y-2 font-mono-accent text-[10px] uppercase tracking-[0.15em] text-white/60">
                  <span className="inline-flex items-center gap-2"><Calendar size={12} className="text-[#005EEA]" /> Tuesdays · 5:30 PM</span>
                  <span className="inline-flex items-center gap-2"><MapPin size={12} className="text-[#005EEA]" /> ALKAME / PaddleZone, Pickering</span>
                </div>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="font-mono-accent text-xs bg-white text-black px-6 py-4 group-hover:bg-[#005EEA] group-hover:text-white transition-colors uppercase tracking-[0.15em]">
                  Claim Your Spot
                </span>
                <ArrowUpRight className="text-[#005EEA] group-hover:text-white transition-colors" size={24} />
              </div>
            </div>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
